import {
  ADD_COMPANY_ALLOWED_IP_ADDRESS_FAIL,
  ADD_COMPANY_ALLOWED_IP_ADDRESS_REQUEST,
  ADD_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS,
  DELETE_COMPANY_ALLOWED_IP_ADDRESS_FAIL,
  DELETE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST,
  DELETE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS,
  GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_REQUEST,
  GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_FAIL,
  GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_SUCCESS,
  GET_COMPANY_ALLOWED_IP_ADDRESS_FAIL,
  GET_COMPANY_ALLOWED_IP_ADDRESS_REQUEST,
  GET_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS,
  UPDATE_COMPANY_ALLOWED_IP_ADDRESS_FAIL,
  UPDATE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST,
  UPDATE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS,
} from "src/constants/types";

export const companyAllowedIpAddressReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        companyAllowedIpAddressList: actions.payload,
        error: "",
      };
    case GET_COMPANY_ALLOWED_IP_ADDRESS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_COMPANY_ALLOWED_IP_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_COMPANY_ALLOWED_IP_ADDRESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_COMPANY_ALLOWED_IP_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_COMPANY_ALLOWED_IP_ADDRESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        companyAllowedIpAddress: actions.payload,
      };
    case GET_COMPANY_ALLOWED_IP_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_COMPANY_ALLOWED_IP_ADDRESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_COMPANY_ALLOWED_IP_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_COMPANY_ALLOWED_IP_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
